// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean, number } from "@altostra/type-validations/lib/primitives";

import type { GenerativeAiStandardsRulesetSynthesisUsageResult } from "./types";

export const isGenerativeAiStandardsRulesetSynthesisUsageResult =
  objectOf<GenerativeAiStandardsRulesetSynthesisUsageResult>({
    unlimited: boolean,
    limit: number,
    remaining: number,
    daily: boolean,
  });
